import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const registrationforms = {
  state: () => ({
    items: [],
    filter: {
      searchTerm: null,
      skip: 0,
      take: 200,
      total: 0,
      page: 1,
      searchTerm: null,
      packetID: null,
      type: null,
    },
    selectedItems: [],
    loading: true,
  }),
  mutations: {
    setRegistrationForms(state, payload) {
      state.items = payload.items;
      state.filter.total = payload.total;
    },
    setSelectedRegistrationForms(state, payload) {
      state.selectedItems = payload;
    },
    setRegistrationFormPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getRegistrationForms");
    },
    setRegistrationFormTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getRegistrationForms");
    },
  },
  actions: {
    async getRegistrationForms(store) {
      store.state.loading = true;
      await axios
        .post("registrationinput/load", {
          ...store.state.filter,
          skip: (store.state.filter.page - 1) * store.state.filter.take,
        })
        .then((res) => {
          store.state.loading = false;
          return store.commit("setRegistrationForms", res.data.data);
        });
    },
    async toggleRegistrationForm(store, payload) {
      var res = await axios.post("registrationinput/toggleisactive", {
        id: store.state.items[payload.index].id,
      });
      return res.data;
    },
    async deleteRegistrationForm(store, payload) {
      await axios
        .post("registrationinput/delete", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);

            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
  },
  getters: {},
};
export default registrationforms;



// WEBPACK FOOTER //
// ./src/store/registrationforms.js